// Native share with copy-to-clipboard fallback. Returns a small status:
// 'shared' | 'copied' | 'cancelled' | 'error'
export const shareOrCopy = async ({ title, text, url }) => {
  // Try native share sheet first (iOS, Android, modern Safari/Chrome)
  if (typeof navigator !== 'undefined' && navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return 'shared';
    } catch (e) {
      // User cancelled — don't fall through to clipboard
      if (e?.name === 'AbortError') return 'cancelled';
      // Real failure — fall through to copy
    }
  }

  // Fallback: copy URL to clipboard
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(url);
      return 'copied';
    }
  } catch (e) { /* fall through */ }

  // Last-ditch: legacy execCommand
  try {
    const ta = document.createElement('textarea');
    ta.value = url;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
    return 'copied';
  } catch (e) {
    return 'error';
  }
};
